import router from '@/router/index';
import userService from "@/api/SAASUserService";
import zoneService from '@/api/zoneService';
import {notify, notifyWarn} from "@/utils/notification-helper";
import MESSAGES from "@/utils/messages"


const state = {
    user: [],
    editId: null,
    newUser: "",
    roles: [],
    zones: [],
    clientsData: [],
    client:{},
    clientId: null,
    auditLogs: [],
    totalAuditLogs: 0
}
const getters = {
    userList: state => state.user,
    newUser: state => state.newUser,
    roleList: state => state.roles,
    zoneList: state => state.zones
}
const actions = {
    async roleList({ commit }) {
        const response = await userService.roleList();
        commit('roleList', response.data.result)
    },
    async getZones({ commit }) {
        const response = await zoneService.getZone()
        commit('getZones', response.data.result)
    },
    async userList({ commit }) {
        const response = await userService.userList();
        commit('userList', response.data.result)
    },
    async removeUser({ commit }, user) {
        await userService.removeUser(user.id)
        commit('remove', user)
    },
    async toggleUserStatus( {dispatch },user) {
        try{
            let data = await userService.toggleUserStatus(user)
            if(data.data?.success !== true){
                dispatch('cancelation', user);
                throw new Error("Something went wrong.")   

            }
        }catch(e){
            throw new Error(e.message)
        }
    },
    async cancelation({ rootState}, user){
        rootState.clients.map(i=>{if(i.id==user.id){
            i.isActive = !user.isActive
        }})
    },
    async editUser({ commit }, user) {
        await userService.editUser(user.id)
        commit('edit', user)
    },
    async addUsers({ commit }, userData) {
        await userService.addUsers(userData)
        commit('addUsers', userData)
    },
    async updateUser({ commit }, userData) {
        await userService.updateUser(state.editId, userData)
        commit('update', userData)
    },
    async searchUser({ commit }, word) {
        const response = await userService.userList();
        const search = word.trim().toLowerCase()
        let list
        if (!search.length) {
            list = response.data.result;
        } else {
            list = response.data.result.filter(item => item.userName.toLowerCase().indexOf(search) > -1)
        }
        commit('userList', list)
    },
    async addClients({ commit, rootState }, clientData) {
        const response = await userService.addClient(clientData);
        if(response.data.success === true) {
            rootState.clients.push(response.result);
            state.clientsData = rootState.clients;
            notify(MESSAGES.CREATE_CLIENT_SUCCESS)
        }
        else{
            let message = response?.data?.message[0] ? response.data.message[0] : MESSAGES.CREATE_CLIENT_FAILED;
            notifyWarn(message);
        }
        commit('addClient', state.clientsData)
    },
    async updateClient({ commit, rootState }, clientData) {
        const response = await userService.updateClient(clientData);
        if(response.data.success === true) {
            const index = rootState.clients.map(item => item.id).indexOf(clientData.id)
            rootState.clients[index] = clientData;
            state.clientsData = rootState.clients;
            notify(MESSAGES.UPDATE_CLIENT_SUCCESS)
        }
        else{
            let message = response?.data?.message[0] ? response.data.message[0] : MESSAGES.UPDATE_CLIENT_FAILED;
            notifyWarn(message);
        }
        commit('addClient', state.clientsData)
    },
    async editClient({ commit }, client) {
        let clientId = client.id;
        commit('editClient', client, clientId)
    },
    async getAuditLogs({commit}, data){
        let auditLog = await userService.getAuditLogs(data.clientId, data.pageSize, data.pageNo);
        if(auditLog.status == 200){
            commit('setAuditLog', auditLog.data.result)
            commit('setTotalAuditLogs', auditLog.data.totalDataCount);
        }
    },
    async getUserAuditLogs({commit}, data){
        let auditLog = await userService.getUserAuditLogs(data.userId, data.pageSize, data.pageNo);
        if(auditLog.status == 200){
            commit('setAuditLog', auditLog.data.result)
            commit('setTotalAuditLogs', auditLog.data.totalDataCount);
        }
    }
}
const mutations = {
    roleList(state, roles) {
        state.roles = roles
    },
    getZones(state, zone){
        state.zones= zone
    },
    userList(state, users) {
        state.user = users
    },
    addUsers(state, users) {
        state.user.push(users);
    },
    remove(state, user) {
        var users = state.user
        const index = users.map(item => item.id).indexOf(user.id)
        users.splice(index, 1)
    },
    edit(state, user) {
        state.editId = user.id
        state.newUser = user
        router.push({ name: "AddUser", params: { add: false } });
    },
    update(state, userData) {
        const index = state.user.map(item => item.name).indexOf(userData.name)
        state.user[index] = userData;
    },
    addClient(state,clientsData) {
        state.clientsData = clientsData;
    },
    editClient(state, client, id) {
        state.clientId = id;
        state.client = client;
        router.push({ name: "AddClient", params: { add: false } });
    },
    setAuditLog(state, data){
        state.auditLogs = data;
    },
    setTotalAuditLogs(state, data){
        state.totalAuditLogs = data;
    }
}

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}




